import { AuthMockApi } from 'app/mock-api/common/auth/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { UserMockApi } from 'app/mock-api/common/user/api';
import { HelpCenterMockApi } from 'app/mock-api/apps/help-center/api';

import { NotificationsMockApi } from 'app/mock-api/common/notifications/api';
import { MessagesMockApi } from 'app/mock-api/common/messages/api';

export const mockApiServices = [
    AuthMockApi,
    NavigationMockApi,
    HelpCenterMockApi,
    NotificationsMockApi,
    MessagesMockApi,
    UserMockApi
];
